export default "__VITE_ASSET__4c986879__"